import { render } from "./CreateTypeUser.vue?vue&type=template&id=77b1c04d&scoped=true"
import script from "./CreateTypeUser.vue?vue&type=script&lang=js"
export * from "./CreateTypeUser.vue?vue&type=script&lang=js"

import "./CreateTypeUser.vue?vue&type=style&index=0&id=77b1c04d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b1c04d"]])

export default __exports__